import { getArticleID } from '.';
import { getSessionFromNext } from '../core/endpoints';

export const getLoginUrl = (brandName: BrandName) => {
  const params = new URLSearchParams({
    redirectUri: location.href,
    dpg_medium: 'Bookmarking',
    dpg_content: 'login',
    dpg_source: brandName,
    dpg_campaign: getArticleID(true) || location.pathname,
  });
  return new URL('/login?' + params, location.origin).toString();
};

// login
export const isLoggedInFromNext = async () => {
  const sessionResponse = await getSessionFromNext();
  const authStatus = sessionResponse.status;
  return authStatus === 'authenticated' || false;
};

export const isLoggedInFromVGW = () => {
  // check if key exists, and if so, it's not empty
  return !!window.sessionStorage.getItem('uid');
};

// login
export const isLoggedIn = async () => {
  //check vkgoweb uid method or check nextjs method. There is a situation where the next endpoint gives a faulty authenticated state, so disabling for now.
  return isLoggedInFromVGW() || isLoggedInFromNext();
};
